import { Flex, HStack, Text, Icon } from '@chakra-ui/react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { memo } from 'react';

import logo from '../../assets/logo.svg';

import CustomConnectButton from '../ConnectWalletButton';
import CustomImage from '../CustomImage';

import HeaderMobile from './mobile';
import { useIsMobile } from '../../hooks/useMobile';
import GameTableInfo from '../GameTableInfo';
import GameStopInfo from '../GameStopInfo';

const Header = () => {
  const location = useLocation();
  const { gameId } = useParams();
  const isGameSettingPage = location.pathname.startsWith('/game-setting');

  const { isMobile } = useIsMobile();

  if (isMobile) {
    return <HeaderMobile />;
  }

  return (
    <Flex
      justifyContent={'space-between'}
      px={3}
      py={4}
      w="100%"
      bg={isGameSettingPage ? 'c-109' : 'bg'}
    >
      <HStack spacing={6} alignItems={'center'}>
        {isGameSettingPage ? (
          <Link to={`/game/${gameId}`}>
            <Flex
              gap={2}
              alignItems={'center'}
              color="c-102"
              _hover={{ color: 'brand' }}
            >
              <BackIcon />
              <Text fontSize={'lg'}>BACK</Text>
            </Flex>
          </Link>
        ) : (
          <Link to={'/'}>
            <CustomImage src={logo} alt="logo" h={12} />
          </Link>
        )}

        {!isGameSettingPage && <GameTableInfo />}
      </HStack>
      {!isGameSettingPage && <GameStopInfo />}

      <CustomConnectButton />
    </Flex>
  );
};

const BackIcon = () => (
  <Icon boxSize={5} viewBox="0 0 20 20">
    <g clipPath="url(#clip0_2262_44314)">
      <path
        d="M20.0002 9.99989H1.11133M1.11133 9.99989L6.66688 4.44434M1.11133 9.99989L6.66688 15.5554"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_2262_44314">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(Header);
